<template>
  <div class="TranProgramModule-view-page w-100">
    <b-overlay :show="loading">
      <!-- Header with customer info -->
      <div class="header-section mb-4 p-3 bg-light rounded" v-if="customerInfo">
        <b-row class="align-items-center">
          <b-col cols="8">
            <div class="d-flex align-items-center flex-wrap">
              <div class="d-flex mr-4 align-items-center">
                <avatar
                  size="40px"
                  :text="customerInfo.fullName"
                  :rounded="true"
                  :src="customerInfo.imageUrl?.url"
                />
                <div class="d-flex flex-column ml-3">
                  <p class="mb-0 font-weight-bolder">{{ customerInfo.fullName }}</p>
                  <p class="mb-0 text-muted small">
                    Gói {{ customerInfo.tranServicePackageName || 'Free' }}
                  </p>
                </div>
              </div>
              <div class="d-flex mr-4 flex-column">
                <p class="mb-0 text-muted small">User code</p>
                <p class="mb-0 font-weight-bold">{{ customerInfo.code }}</p>
              </div>
              <div class="d-flex mr-4 flex-column">
                <p class="mb-0 text-muted small">Năm sinh</p>
                <p class="mb-0 font-weight-bold">
                  {{ convertTimestampToDate(customerInfo.dateOfBirth, 'YYYY') }}
                </p>
              </div>
              <div class="d-flex mr-4 flex-column">
                <p class="mb-0 text-muted small">Giới tính</p>
                <p class="mb-0 font-weight-bold">{{ customerInfo.gender }}</p>
              </div>
              <div class="d-flex mr-4 flex-column" v-if="customerInfo.diabetes">
                <p class="mb-0 text-muted small">Tình trạng</p>
                <p class="mb-0 font-weight-bold">{{ customerInfo.diabetes.name }}</p>
              </div>
            </div>
          </b-col>
          <b-col cols="4" class="text-right">
            <b-dropdown
              id="dropdown-filter"
              class="dropdown-form-filter mr-2"
              no-caret
              right
            >
              <template #button-content>
                <span class="svg-icon">
                  <inline-svg src="/media/svg/icons/Neolex/Basic/filter.svg" />
                </span>
                Bộ lọc
              </template>
              <b-dropdown-form style="min-width: 500px;">
                <b-container class="p-3">
                  <b-row>
                    <b-col cols="6">
                      <basic-select
                        label="Loại hoạt động"
                        placeholder="Chọn loại hoạt động"
                        name="activityType"
                        :options="activityTypes"
                        :value.sync="filter.activityTypeId"
                        track-by="value"
                        value-label="name"
                      />
                    </b-col>
                    <b-col cols="6">
                      <basic-select
                        label="ServicePackage"
                        placeholder="Chọn ServicePackage"
                        name="servicePackage"
                        :options="servicePackages"
                        :value.sync="filter.servicePackage"
                        track-by="Id"
                        value-label="Name"
                      />
                    </b-col>
                    <b-col cols="6">
                      <basic-date-picker
                        :value.sync="filter.startDate"
                        label="Ngày bắt đầu"
                        placeholder="Ngày bắt đầu"
                        format="YYYY-MM-DD"
                      />
                    </b-col>
                    <b-col cols="6">
                      <basic-date-picker
                        :value.sync="filter.endDate"
                        label="Ngày kết thúc"
                        placeholder="Ngày kết thúc"
                        format="YYYY-MM-DD"
                      />
                    </b-col>
                  </b-row>
                  <div class="d-flex justify-content-end mt-3">
                    <b-button class="btn mr-2" @click="resetFilter">
                      Reset
                    </b-button>
                    <b-button class="btn btn-primary" @click="searchRequest">
                      Lọc dữ liệu
                    </b-button>
                  </div>
                </b-container>
              </b-dropdown-form>
            </b-dropdown>
            <b-button class="btn" @click="resetRequest">
              <span class="svg-icon">
                <inline-svg src="/media/svg/icons/Neolex/Basic/refresh-cw.svg" />
              </span>
              Làm mới
            </b-button>
          </b-col>
        </b-row>
      </div>

      <!-- Activity Schedule -->
      <div v-show="moduleData.activities && moduleData.activities.length > 0">
        <ScheduleTranUserPackageDay
          ref="ScheduleServicePackageDay"
          :key="'schedule-' + accountId + '-' + moduleData.activities.length"
          :moduleData="moduleData"
          :moduleId="accountId"
          @edit-activity="editActivity"
        />
      </div>
      <div v-show="!moduleData.activities || moduleData.activities.length === 0" class="text-center py-5">
        <p class="text-muted">Không có dữ liệu hoạt động</p>
      </div>

      <!-- Activity Detail Modal -->
      <ModalCreateDetail
        ref="modalCreate"
        :key="selectedItems?.timestamp || 'default'"
        :setupData="setupData"
        @loadData="loadTranUserPackageActivity"
        :selectedItem="selectedItems"
      />
    </b-overlay>
  </div>
</template>

<script>
import moment from 'moment';
import ScheduleTranUserPackageDay from '@/view/pages/tran_user_package/components/ScheduleTranUserPackageDay.vue';

export default {
  name: 'TranUserPackageEmbed',
  components: {
    ScheduleTranUserPackageDay,
    ModalCreateDetail: () =>
      import('@/view/pages/tran_user_package/components/modal/ModalCreateActivity.vue'),
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      customerInfo: null,
      moduleData: {
        activities: [],
        totalWeek: 1,
        actualDays: [],
      },
      numberOfWeeks: 1,
      activityTypes: [],
      activities: [],
      servicePackages: [],
      programs: [],
      modules: [],
      setupData: null,
      selectedItems: null,
      defaultColor: '#16A45A',
      filter: {
        activityTypeId: null,
        servicePackage: null,
        programId: null,
        moduleId: null,
        startDate: null,
        endDate: null,
      },
    };
  },
  mounted() {
    if (this.accountId) {
      this.$nextTick(() => {
        this.loadAllData();
      });
    }
  },
  watch: {
    accountId(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.loadAllData();
        });
      }
    },
  },
  methods: {
    async loadAllData() {
      this.loading = true;
      try {
        // Load activityTypes first (needed for color mapping in activities)
        await this.loadActivityType();
        // Then load the rest in parallel
        await Promise.all([
          this.getPatientData(),
          this.getSetupSearchMenu(),
          this.loadTranUserPackageActivity(),
        ]);
      } catch (error) {
        console.error('Error loading data:', error);
      } finally {
        this.loading = false;
      }
    },

    async loadActivityType() {
      try {
        const { data } = await this.$api.get('/ProgramActivityLevel/setup-list');
        this.setupData = data;
        this.activityTypes = data.Types.map((item) => ({
          value: item.Id,
          name: item.Name,
          color: item.Color,
        }));
      } catch (error) {
        console.error('Error loading activity types:', error);
        this.activityTypes = [];
      }
    },

    async getPatientData() {
      try {
        const { data } = await this.$api.get(`Patient/accountId?id=${this.accountId}`);
        this.customerInfo = data;
      } catch (error) {
        console.error('Error loading patient data:', error);
      }
    },

    async getSetupSearchMenu() {
      try {
        const { data } = await this.$api.get(
          `TranUserPackage/setup-list?accountId=${this.accountId}`
        );
        this.servicePackages = data.tranServicePackages || [];
        this.programs = data.tranPrograms || [];
        this.modules = data.programModules || [];
      } catch (error) {
        console.error('Error loading setup menu:', error);
      }
    },

    async loadTranUserPackageActivity(showLoading = false) {
      if (!this.accountId) return;

      try {
        if (showLoading) this.loading = true;
        const response = await this.$api.get('TranUserPackage/accountId', {
          params: {
            accountId: this.accountId,
            ...this.searchParams(),
          },
        });

        const data = response?.data;
        const items = Array.isArray(data?.items)
          ? data.items
          : Array.isArray(data)
          ? data
          : [];

        if (!items.length) {
          const today = moment().startOf('day');
          const startOfWeek = today.clone().startOf('isoWeek');
          const actualDays = Array.from({ length: 7 }, (_, index) =>
            startOfWeek.clone().add(index, 'days').format('DD/MM/YYYY')
          );
          this.moduleData = Object.assign({}, { activities: [], totalWeek: 1, actualDays: [...actualDays] });
          this.numberOfWeeks = 1;
          return;
        }

        const minStartDate = Math.min(
          ...items.map((activity) => activity.tranStartDate || moment().unix())
        );
        const maxStartDate = Math.max(
          ...items.map((activity) => activity.tranStartDate || moment().unix())
        );
        const totalDays =
          moment.unix(maxStartDate).diff(moment.unix(minStartDate), 'days') + 1;
        const totalWeek = Math.ceil(totalDays / 7) || 1;
        const adjustedTotalWeek = totalWeek + 1;

        const startOfWeek = moment.unix(minStartDate).startOf('isoWeek');
        const actualDays = Array.from(
          { length: adjustedTotalWeek * 7 },
          (_, index) =>
            startOfWeek.clone().add(index, 'days').format('DD/MM/YYYY')
        );

        const activities = items.map((activity) => {
          const type = this.activityTypes.find(
            (t) => t.value === activity.activityTypeId
          );
          return {
            id: activity.id,
            accountId: activity.accountId,
            name: activity.name || 'Không xác định',
            startAtDay: this.calculateStartAtDay(activity.tranStartDate, minStartDate),
            actualDate: moment.unix(activity.tranStartDate).format('DD/MM/YYYY'),
            color: type?.color || this.defaultColor,
            activityModuleMappingId: activity.id,
            code: activity.code || null,
            userPackageId: activity.userPackageId,
            activityId: activity.tranProgramActivityId,
            status: activity.status || null,
            surveyId: activity.surveyId || null,
            questionSurveys: activity.questionSurveys || null,
            bloodSugarCount: activity.bloodSugarCount || null,
          };
        });

        // Force new reference for reactivity
        this.moduleData = Object.assign({}, {
          activities: [...activities],
          totalWeek: adjustedTotalWeek,
          actualDays: [...actualDays],
        });
        this.numberOfWeeks = adjustedTotalWeek;

        await this.$nextTick();
        if (this.$refs.ScheduleServicePackageDay) {
          this.$refs.ScheduleServicePackageDay.updateNumberOfWeeks(this.numberOfWeeks);
        }
      } catch (error) {
        console.error('Error loading activities:', error);
        const today = moment().startOf('day');
        const startOfWeek = today.clone().startOf('isoWeek');
        const actualDays = Array.from({ length: 7 }, (_, index) =>
          startOfWeek.clone().add(index, 'days').format('DD/MM/YYYY')
        );
        this.moduleData = Object.assign({}, { activities: [], totalWeek: 1, actualDays: [...actualDays] });
        this.numberOfWeeks = 1;
      } finally {
        if (showLoading) this.loading = false;
      }
    },

    searchParams() {
      return this.removeEmpty({
        activityTypeId: this.filter.activityTypeId,
        tranServicePackageId: this.filter.servicePackage,
        tranProgramId: this.filter.programId,
        tranProgramModuleId: this.filter.moduleId,
        tranStartDate: this.convertDateToTimestamp(this.filter.startDate),
        tranEndDate: this.convertDateToTimestamp(this.filter.endDate),
      });
    },

    removeEmpty(obj) {
      const newObj = {};
      for (let key in obj) {
        if (obj[key] !== null && obj[key] !== undefined && obj[key] !== '') {
          newObj[key] = obj[key];
        }
      }
      return newObj;
    },

    convertDateToTimestamp(date) {
      if (!date) return null;
      return Math.floor(new Date(date).getTime() / 1000);
    },

    convertTimestampToDate(timestamp, format = 'DD/MM/YYYY') {
      return timestamp ? moment(timestamp * 1000).format(format) : null;
    },

    calculateStartAtDay(tranStartDate, minStartDate) {
      const startDate = moment.unix(tranStartDate || moment().unix());
      const baseDate = moment.unix(minStartDate);
      const startOfWeek = baseDate.clone().startOf('isoWeek');
      const diffDays = startDate.diff(startOfWeek, 'days') + 1;
      return diffDays >= 1 ? diffDays : 1;
    },

    searchRequest() {
      this.loadTranUserPackageActivity(true);
      document.body.click();
    },

    resetFilter() {
      this.filter = {
        activityTypeId: null,
        servicePackage: null,
        programId: null,
        moduleId: null,
        startDate: null,
        endDate: null,
      };
      this.loadTranUserPackageActivity(true);
      document.body.click();
    },

    async resetRequest() {
      await this.loadAllData();
      this.$toastr.s({
        title: 'Thành công!',
        msg: 'Dữ liệu đã được làm mới',
      });
    },

    async editActivity(activity) {
      try {
        const { data } = await this.$api.get(
          `TranProgramActivity/tran-user-package-activity/${activity.id}`
        );
        this.selectedItems = {
          action: 'view',
          item: { ...data },
          timestamp: Date.now(),
        };
        await this.$nextTick();
        if (this.$refs.modalCreate) {
          this.$refs.modalCreate.openModal();
        }
      } catch (error) {
        console.error('Error loading activity:', error);
        this.$toastr.e({
          title: 'Lỗi!',
          msg: 'Không thể tải dữ liệu hoạt động',
        });
      }
    },

  },
};
</script>

<style lang="scss" scoped>
.header-section {
  border: 1px solid #e4e6ef;
}

.dropdown-form-filter {
  .dropdown-menu {
    min-width: 500px;
  }
}
</style>
